// Library imports
import React, { useState } from "react";

// User Component imports
import OpsDialog from "../common/OpsDialog";
import { groupOf, verLabel } from "../utils/promptVersions";
import PromptDiffView, { DiffNav, DiffToggles, useDiffOps, useDiffNav, diffCountLabel } from "./PromptDiffView";

/**
 * 差分モーダル（閲覧 / 適用の確認）
 * 閲覧はフッターが無く×が唯一の閉じる手段・背景クリックで閉じる。
 * 適用の確認はフッターにキャンセルがあるため×を出さず、背景クリックで閉じる（CLAUDE.md モーダルの閉じ方ルール）。
 */
const PromptDiffModal = ({ modal, group, isBusy, onChangeTab, onClose, onApply }) => {
    const [fullText, setFullText] = useState(false);
    const isApply = modal.mode === "apply";
    const groupKey = modal.groupKey;
    const tab = modal.tab;

    const sysDiff = useDiffOps(group.system_prompt, modal.right.sys);
    const userDiff = useDiffOps(group.user_prompt, modal.right.user);
    const { ops, count, rows, hunks, stat } = tab === "sys" ? sysDiff : userDiff;
    const nav = useDiffNav(hunks, tab);

    const rightTitle = modal.v === null ? "現在の編集" : verLabel(modal.v, groupKey);

    const footer = isApply ? (
        <>
            <div className="ops-diff-apply-note">
                <i className="bi bi-exclamation-triangle-fill" />
                <span>
                    適用すると稼働中のAIの応答にすぐ反映されます。
                </span>
            </div>
            <button type="button" className="ops-footer-btn" onClick={onClose}>キャンセル</button>
            <button type="button" className="ops-footer-btn is-primary" disabled={isBusy} onClick={onApply}>適用する</button>
        </>
    ) : null;

    return (
        <OpsDialog
            show={true}
            className="ops-scope ops-diff-dialog"
            title={isApply ? `${verLabel(modal.v, groupKey)} を適用` : "差分"}
            subtitle={<>{groupOf(groupKey)?.name ?? ""}<span className="ops-diff-count">{diffCountLabel(count)}</span></>}
            width={1760}
            headerRight={<>
                <DiffNav stat={stat} nav={nav} />
                <DiffToggles tab={tab} onChangeTab={onChangeTab} fullText={fullText} onChangeFullText={setFullText}
                    counts={{ sys: sysDiff.count, user: userDiff.count }} />
            </>}
            footer={footer}
            showClose={!isApply}
            onClose={onClose}
            bodyClassName="ops-diff-body"
        >
            <PromptDiffView ops={ops} rows={rows} nav={nav} tab={tab} leftTitle={`適用中（${verLabel(group.deployed_v, groupKey)}）`} rightTitle={rightTitle}
                fullText={fullText} onShowFull={() => setFullText(true)} />
        </OpsDialog>
    );
};

export default PromptDiffModal;
